import { render, staticRenderFns } from "./NovaPoshtaModule.vue?vue&type=template&id=e06e1cc0"
import script from "./NovaPoshtaModule.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports